<template>
  <a-card :bordered='false'>
    <div class="outBox">
      <div class="insideBox s_flex_ali">
        <p>1、在线订货功能目前仅支持二级分类<br />2、添加完分类后，需要将已上传的商品进行关联，可在商品列表进行批量设置分类；关联的上架产品数为0时，用户端不显示。</p>
      </div>
    </div>
    <div class='mb25 m-b-25  s_flex_bian_c m-t-25'>
      <div class="s_flex_ali">
        <span class='mr15'>
          <a-button type="primary" v-has:onlineCateAddOne="visibleToggle">
            新增一级分组
          </a-button>
        </span>
        <!-- <span class='mr15' v-if="cateList.length">
          <a-button type="link" @click="changActiveKey">
            {{activeKey.length?'收起所有分类':'展开所有分类'}}
          </a-button>
        </span> -->
      </div>
      <span class="m-r-10">
        提示：长按可以对同级分类进行拖动排序
      </span>
    </div>
    <a-collapse v-if="cateList.length" @change="changActive" v-model:activeKey="activeKey" >
      <a-collapse-panel :header="v.name" v-for="(v,key) in cateList" :key='String(key)' draggable="true"  @drag="actionDrag(event)">
        <template #extra>
          <a-button type="link" v-has:onlineCateAddTwo="()=>{visibleToggle();group.pid=v.id;}">
            新增二级分类
          </a-button>-
          <a-button type="link" v-has:onlineCateEditOne="()=>{group=JSON.parse(JSON.stringify(v));visible=true;groupForm.resetFields()}">
            修改
          </a-button>-
          <a-button type="link" v-has:onlineCateDelOne="()=>del(v.id)">
            删除
          </a-button>
        </template>
        <div v-for="(value,key) in v.children" :key="key" class='p-t-15 p-b-15 p-l-100 secondCate s_flex_bian_c m-b-10' style="background:#ECECEC;" draggable="true"  @drag="actionDrag(event)"> 
          <span class='width-100'>{{ value.name }}</span>
          <div>
            <a-button type="link" v-has:onlineCateEditTwo="()=>{group=JSON.parse(JSON.stringify(value));visible=true;groupForm.resetFields()}">
              修改
            </a-button>-
            <a-button type="link" v-has:onlineCateDelTwo="()=>del(value.id)">
              删除
            </a-button>
          </div>
        </div>
        <a-divider type="vertical" />
      </a-collapse-panel>
    </a-collapse>
    <a-empty v-if="!cateList.length" :description="false" />
  </a-card>
  <!-- 添加分类 -->
  <a-modal title="分类管理" centered v-model:visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" destroyOnClose>
    <a-form ref="groupForm" :model="group" :label-col="{span:4}" :wrapper-col="{span:20}" help='限8个字符'>
      <a-form-item ref="name" label="分组名称" name="name" :rules="[{ required: true, message: '请输入分类名称' },{ max: 20, message: '分组名称不超过20个字符' }]">
        <a-input v-model:value="group.name" placeholder='请输入分类名称' />
      </a-form-item>
        <!-- <a-form-item ref="image_url" label="产品图片" name="image_url" :rules="[{ required: true, message: '请添加产品图片' }]" help="图片宽高要求1:1比例，建议尺寸为640px*640px以上；最多上传5张图片。">
        <material :groupType="1" :imageList="form.image_url" :max="5" 
        v-on:handlechoose="(data) => {form.image_url.push(...data);}
          " v-on:handledel="(data) => {form.image_url = data;}" />
      </a-form-item> -->
      <a-form-item ref="id" label="id" name="id" hidden>
        <a-input v-model:value="group.id" />
      </a-form-item>
      <a-form-item ref="pid" label="pid" name="pid" hidden>
        <a-input v-model:value="group.pid" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { iscode } from "@/utils/app";
import { onMounted, reactive, toRefs, ref, watch } from "vue";
import store from "@/store";
import config from "@/config";
import {getGoodsCategory,createGoodsCategory,delGoodsCategory,updateGoodsCategory} from '@/api/online.js'
import { getToken } from "@/libs/util";
import { Modal } from "ant-design-vue";
export default {
  name: "product",
  setup(props) {
    const state = reactive({
      cateList: [],
      visible: false,
      confirmLoading: false,
      activeKey: "",
      link: "",
    });
    state.link =
      config.cloudUrl[process.env.VUE_APP_type] +
      "product/productCate?picdomain=" +
      store.state.user.info.picdomain +
      "&token=" +
      getToken()+'&brand_mark='+store.state.user.info.brand_mark;
    const initData = async () => {
      let result = await getGoodsCategory().then((res) => res.data);
      state.cateList = result.data;
    };
    watch(state.visible, () => {
      groupForm.value.resetFields();
    });

    // 定义分类表单绑定数据
    const group = ref({ group_name: "", sort: 100, id: null, pid: null });
    // 定义分类表单ref
    const groupForm = ref();
    // 提交
    const handleOk = () => {
      groupForm.value
        .validate()
        .then(async (res) => {
          state.confirmLoading = true;
          var result;
          if (!res.id) {
            result = await createGoodsCategory(res);
          } else {
            // 修改分类
            result = await updateGoodsCategory(res.id, res);
          }
          if (iscode(result.data, true)) {
            state.visible = false;
            initData();
            groupForm.value.resetFields();
          }

          state.confirmLoading = false;
        })
        .catch((error) => {});
    };
    // 弹出表单
    const visibleToggle = () => {
      group.value = { name: "", sort: 100, id: null, pid: null };
      state.visible = true;
      //  groupForm.value.resetFields();
    };
    // 删除
    const del = (id) => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await delGoodsCategory(id).then((res) => res.data);
          if (iscode(res, true)) {
            initData();
          }
        },
      });
    };
    const changActiveKey = () => {
      if (state.activeKey.length) {
        state.activeKey = [];
      } else {
        state.activeKey = [];
        state.cateList.forEach((v, key) => {
          state.activeKey.push(String(key));
        });
      }
    };
    const changActive = (key) => {
      state.activeKey = [];
      key.forEach((element) => {
        state.activeKey.push(String(element));
      });
      // state.activeKey=[key]
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      handleOk,
      group,
      groupForm,
      del,
      visibleToggle,
      changActive,
      changActiveKey,
      getToken,
    };
  },
};
</script>
